export default __webpack_public_path__ + "static/media/mongodb.339f3495.png";